import '../../pages/Notification/Notification.css'
import { BiSolidCircle } from "react-icons/bi";

function timeAgo(dateString) {
  const now = new Date();
  const past = new Date(dateString);
  const diff = now - past;

  const diffMinutes = Math.floor(diff / (1000 * 60));
  const diffHours = Math.floor(diff / (1000 * 60 * 60));
  const diffDays = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (diffMinutes < 1) return '방금 전';
  if (diffMinutes < 60) return `${diffMinutes}분 전`;
  if (diffHours < 24) return `${diffHours}시간 전`;
  if (diffDays < 7) return `${diffDays}일 전`;
  
  // 7일이 넘어가면 그냥 날짜로 보여줌
  return past.toLocaleDateString('ko-KR'); 
}

export default function NotificationCard({id, title, content, is_read, created_at, handleClickCard, isDeleteMode, isSelected}){
  const formattedTime = timeAgo(created_at+ 'Z');

  return(
    <div className="notificationCard" onClick={handleClickCard}>
      <div className="notificationCard-top">
        {isDeleteMode &&
        <input 
                type="checkbox" 
                checked={isSelected} 
                readOnly
              /> }
        {is_read==false && <BiSolidCircle className="red-circle"/>} <h3>{title}</h3></div>
      <p>{formattedTime}</p>
    </div>
  );
}